import { default as health_45check5EvNYHYRtZMeta } from "/usr/src/rt-details-2023/pages/health-check.vue?macro=true";
import { default as indexGwQNVYbBSdMeta } from "/usr/src/rt-details-2023/pages/index.vue?macro=true";
import { default as articlesQZXERr2exmMeta } from "/usr/src/rt-details-2023/pages/research-topics/[rtId]/[rtSlug]/articles.vue?macro=true";
import { default as authorsykpvb7vXpiMeta } from "/usr/src/rt-details-2023/pages/research-topics/[rtId]/[rtSlug]/authors.vue?macro=true";
import { default as impactCKtctcnOptMeta } from "/usr/src/rt-details-2023/pages/research-topics/[rtId]/[rtSlug]/impact.vue?macro=true";
import { default as index4rEO0VXuPWMeta } from "/usr/src/rt-details-2023/pages/research-topics/[rtId]/[rtSlug]/index.vue?macro=true";
import { default as overview3vscsObBRWMeta } from "/usr/src/rt-details-2023/pages/research-topics/[rtId]/[rtSlug]/overview.vue?macro=true";
import { default as indexMmrxECLF7yMeta } from "/usr/src/rt-details-2023/pages/research-topics/[rtId]/index.vue?macro=true";
export default [
  {
    name: "health-check",
    path: "/health-check",
    meta: health_45check5EvNYHYRtZMeta || {},
    component: () => import("/usr/src/rt-details-2023/pages/health-check.vue").then(m => m.default || m)
  },
  {
    name: "index",
    path: "/",
    meta: indexGwQNVYbBSdMeta || {},
    component: () => import("/usr/src/rt-details-2023/pages/index.vue").then(m => m.default || m)
  },
  {
    name: "research-topics-rtId-rtSlug-articles",
    path: "/research-topics/:rtId()/:rtSlug()/articles",
    component: () => import("/usr/src/rt-details-2023/pages/research-topics/[rtId]/[rtSlug]/articles.vue").then(m => m.default || m)
  },
  {
    name: "research-topics-rtId-rtSlug-authors",
    path: "/research-topics/:rtId()/:rtSlug()/authors",
    component: () => import("/usr/src/rt-details-2023/pages/research-topics/[rtId]/[rtSlug]/authors.vue").then(m => m.default || m)
  },
  {
    name: "research-topics-rtId-rtSlug-impact",
    path: "/research-topics/:rtId()/:rtSlug()/impact",
    component: () => import("/usr/src/rt-details-2023/pages/research-topics/[rtId]/[rtSlug]/impact.vue").then(m => m.default || m)
  },
  {
    name: "research-topics-rtId-rtSlug",
    path: "/research-topics/:rtId()/:rtSlug()",
    component: () => import("/usr/src/rt-details-2023/pages/research-topics/[rtId]/[rtSlug]/index.vue").then(m => m.default || m)
  },
  {
    name: "research-topics-rtId-rtSlug-overview",
    path: "/research-topics/:rtId()/:rtSlug()/overview",
    meta: overview3vscsObBRWMeta || {},
    component: () => import("/usr/src/rt-details-2023/pages/research-topics/[rtId]/[rtSlug]/overview.vue").then(m => m.default || m)
  },
  {
    name: "research-topics-rtId",
    path: "/research-topics/:rtId()",
    meta: indexMmrxECLF7yMeta || {},
    component: () => import("/usr/src/rt-details-2023/pages/research-topics/[rtId]/index.vue").then(m => m.default || m)
  }
]